module.exports = __webpack_public_path__ + "51de54064b142890b9d50ce1e6995176.svg";